// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "../Utilities/ApiEndpoint.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as AuthenticationSessionMethods$OrcaPaymentPage from "./AuthenticationSessionMethods.bs.js";

function make(options, clientSecret, publishableKey, logger) {
  var logger$1 = Core__Option.getOr(logger, LoggerUtils$OrcaPaymentPage.defaultLoggerConfig);
  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKey, undefined);
  var customPodUri = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(options), "customPodUri", "");
  var profileId = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(options), "profileId", "");
  var authenticationId = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(options), "authenticationId", "");
  var merchantId = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(options), "merchantId", "");
  return {
          initClickToPaySession: (function (initClickToPaySessionInput) {
              return AuthenticationSessionMethods$OrcaPaymentPage.initClickToPaySession(clientSecret, publishableKey, logger$1, customPodUri, endpoint, profileId, authenticationId, merchantId, initClickToPaySessionInput, undefined);
            }),
          getActiveClickToPaySession: (function () {
              return AuthenticationSessionMethods$OrcaPaymentPage.getActiveClickToPaySession(clientSecret, publishableKey, logger$1, customPodUri, endpoint, profileId, authenticationId, merchantId);
            })
        };
}

export {
  make ,
}
/* Utils-OrcaPaymentPage Not a pure module */
